import React from 'react';
import PropTypes from 'prop-types';
import creditCardType from 'credit-card-type';

import {CARD_LOGOS} from '../../../consts';

export function formatCardNumber(value) {
    const v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
    const matches = v.match(/\d{4,19}/g);
    const match = (matches && matches[0]) || '';
    const parts = [];

    for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
    }

    if (parts.length) {
        return parts.join(' ');
    }

    return value;
}

// Added data to check the type of Visa-Electron card
creditCardType.addCard({
    niceType: 'Visa Electron',
    type: 'visaElectron',
    patterns: [4026, 417500, 42, 4405, 4508, 4844, 4913, 4917],
    gaps: [4, 8, 12],
    lengths: [16],
    code: {
        name: 'CVV',
        size: 3
    }
});

class CardNumberInputField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cardType: {}
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        const {cardType} = this.state;
        const {onCardTypeChange} = this.props;

        if (onCardTypeChange && prevState.cardType.type !== cardType.type) {
            onCardTypeChange(cardType);
        }
    }

    handleChange(e) {
        const {value} = e.target;
        const {field: {name}, form: {setFieldValue}, onChange} = this.props;
        const formattedValue = formatCardNumber(value);
        const cardTypes = creditCardType(formattedValue);
        const cardType = value && cardTypes.length > 0 ? cardTypes[0] : {};

        setFieldValue(name, formattedValue);

        this.setState({
            cardType
        });

        onChange(e, formattedValue);
    }

    render() {
        const {cardType} = this.state;
        const {
            field, form, onCardTypeChange, ...restProps
        } = this.props;

        return (
            <div className="cardnumber-input">
                <input type="text" {...restProps} {...field} onChange={this.handleChange} />

                {/* Icon of card type */}
                {cardType.type && (
                    <img
                        className="cardnumber-icon"
                        src={CARD_LOGOS[cardType.type] || CARD_LOGOS.optileOther}
                        alt={cardType.type}
                    />
                )}
            </div>
        );
    }
}

CardNumberInputField.propTypes = {
    onChange: PropTypes.func,
    onCardTypeChange: PropTypes.func
};

CardNumberInputField.defaultProps = {
    onChange: () => {},
    onCardTypeChange: () => {}
};

export default CardNumberInputField;
